import { IconArrowsExchange } from "@tabler/icons-react";

const DEFAULT_COLOR = "#2563EB";

type CorridorDoubleArrowProps = {
  size?: number;
  color?: string;
};

export default function CorridorDoubleArrow({ size = 22, color = DEFAULT_COLOR }: CorridorDoubleArrowProps) {
  return <IconArrowsExchange size={size} color={color} stroke={2.25} style={{ flexShrink: 0 }} />;
}
